import { Field } from 'formik'

import { Input } from '../Input'

export const FormikInput = (props: Input) => (
  <Field
    name={props.name}
    render={({ field, form: { touched, errors } }) => (
      <Input
        {...props}
        {...field}
        error={touched[field.name] && errors[field.name]}
      />
    )}
  />
)
